import { render, staticRenderFns } from "./DataTableRowMenu.vue?vue&type=template&id=4f29918a&scoped=true"
import script from "./DataTableRowMenu.vue?vue&type=script&lang=js"
export * from "./DataTableRowMenu.vue?vue&type=script&lang=js"
import style0 from "./DataTableRowMenu.vue?vue&type=style&index=0&id=4f29918a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f29918a",
  null
  
)

export default component.exports